import { createClient } from '@supabase/supabase-js'

// Project ID and Anon Key
const SUPABASE_URL = 'https://msftcrtyfjlzqrpwedll.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zZnRjcnR5ZmpsenFycHdlZGxsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY2NjU3NzEsImV4cCI6MjA4MjI0MTc3MX0.G6NKZieV5TCPB7so67aVgMjZscVXtkX_9yvOE2ChrxM'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

// Export as a named constant to match imports in hooks
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})